import gql from 'graphql-tag';

export const rejectPhotoMutation = gql`
  mutation rejectPhoto($approvalId: String!, $rejectionReason: String!) {
    rejectPhoto(approvalId: $approvalId, rejectionReason: $rejectionReason)
  }
`;
